import { render, staticRenderFns } from "./AddGroupTournament.vue?vue&type=template&id=510dd247&scoped=true"
import script from "./AddGroupTournament.vue?vue&type=script&lang=js"
export * from "./AddGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./AddGroupTournament.vue?vue&type=style&index=0&id=510dd247&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510dd247",
  null
  
)

export default component.exports